import { intersection } from 'lodash'

import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import MachinesApi from '@/services/apiServiceModules/machinesApi'
const machinesApi = new MachinesApi()

const elementMatchesQueryParams = (element, query) => {
	const queryResult = {}
	Object.keys(query).forEach((key) => {
		queryResult[key] = null
		switch (key) {
			case 'legal_entity_ids':
				if (query[key].length > 0) {
					queryResult[key] = query[key].includes(element.entity)
				}
				break
			case 'machine_types':
				if (query[key].length > 0) {
					queryResult[key] = query[key].includes(element.machine_type)
				}
				break
			case 'machine_group_ids':
				if (query[key].length > 0) {
					queryResult[key] = intersection(query[key], element.groups).length >= 1
				}
				break
			case 'machine_ids':
				if (query[key].length > 0) {
					queryResult[key] = query[key].includes(element.id)
				}
				break
			case 'property_types':
				if (query[key].length > 0) {
					queryResult[key] = query[key].includes(element.property)
				}
				break
			default:
				queryResult[key] = query[key].includes(element[key])
				break
		}
	})
	return Object.values(queryResult).every((value) => value === true)
}

export default class MachinesDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.MACHINES, machinesApi, {
			useCache: true,
		})
	}

	/**
	 * @description бэкенд всегда отдаёт полный список машин компании,
	 * фильтрация по query выполняется на клиенте
	 */
	getAvailableMachines(companyId, query) {
		return this.getEntities(companyId).then((res) => {
			const possibleQueryParams = {}
			Object.keys(query ?? {}).forEach((key) => {
				if ([
					'legal_entity_ids',
					'machine_types',
					'machine_group_ids',
					'machine_ids',
					'property_types',
				].includes(key)) {
					possibleQueryParams[key] = query[key]
				}
			})

			if (Object.keys(possibleQueryParams).length === 0) {
				return res
			}

			return res.filter((element) => elementMatchesQueryParams(element, possibleQueryParams))
		})
	}

	getSensorsValues(companyId, machineId, query) {
		const config = {
			apiServiceMethodName: 'getSensorsValues',
		}

		const apiMethodPayload = {
			urlParams: {
				companyId,
				entityId: machineId,
			},
		}

		if (query && typeof query === 'object') {
			apiMethodPayload.params = query
		}

		return this.dataTransferWrapMethod(this.moduleName, this.apiModule, config, apiMethodPayload)
	}

	getRawGPSParams(companyId, machineId, query) {
		const config = {
			apiServiceMethodName: 'getRawGPSParams',
		}

		const apiMethodPayload = {
			urlParams: {
				companyId,
				entityId: machineId,
			},
		}

		if (query && typeof query === 'object') {
			apiMethodPayload.params = query
		}

		return this.dataTransferWrapMethod(this.moduleName, this.apiModule, config, apiMethodPayload)
	}
}
